import { render, staticRenderFns } from "./TabelaAvaliacaoFinal.vue?vue&type=template&id=0b5a751e&"
import script from "./TabelaAvaliacaoFinal.vue?vue&type=script&lang=js&"
export * from "./TabelaAvaliacaoFinal.vue?vue&type=script&lang=js&"
import style0 from "./TabelaAvaliacaoFinal.vue?vue&type=style&index=0&id=0b5a751e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports